import Cookies from 'universal-cookie';
import { getDateYearsFromNow } from 'Utils/Date';
import store from '../store';
import {
  ANALYTICS_SET_PAGE_NAME,
  ANALYTICS_SET_PAGE_SOURCE,
  ANALYTICS_SET_PURCHASE_SOURCE,
  SET_SOURCE,
} from '../Types';
import { getDefaultConfig } from 'Utils/Store';

const setPurchaseSourceCookie = (purchaseSource) => {
  const { cookieDomain, purchaseSourceCookieName } = getDefaultConfig();
  const oneYear = getDateYearsFromNow(1);
  const cookieOptions = { path: '/', domain: cookieDomain, expires: oneYear };

  const cookies = new Cookies();
  cookies.set(purchaseSourceCookieName, purchaseSource, cookieOptions);
};

const getQueryStringSource = (window) => {
  const query = new URLSearchParams(window && window.location && window.location.search);
  const source = query.get('source');
  console.debug(`Query string source: ${source}`);
  return source;
};

const getReferrerSource = () => {
  const referrer = document && document.referrer;
  console.debug(`Referrer: ${referrer}`);
  return referrer;
};

export const setSource = (window) => {
  const source = getQueryStringSource(window) || getReferrerSource();
  console.debug(`Adding Source '${source}' to the store...`);
  return { type: SET_SOURCE, payload: source };
};

export const boundSetSource = (window) => store.dispatch(setSource(window));
export const trackPageSource = (payload) => store.dispatch({ type: ANALYTICS_SET_PAGE_SOURCE, payload });
export const trackPageName = (payload) => store.dispatch({ type: ANALYTICS_SET_PAGE_NAME, payload });
export const trackPurchaseSource = (payload = '') => {
  setPurchaseSourceCookie(payload);
  return store.dispatch({ type: ANALYTICS_SET_PURCHASE_SOURCE, payload });
};
